import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-home\">\n<g id=\"icon-home_Menu/home\">\n<g id=\"icon-home_Icon/home\">\n<g id=\"icon-home_home\">\n<path d=\"M6.00004 11.0001V12.0001H10V11.0001H6.00004Z\" fill=\"#282C33\" />\n<path d=\"M7.64648 1.64652C7.84175 1.45126 8.15833 1.45126 8.35359 1.64652L14.8536 8.14652L14.1465 8.85363L13 7.70718V13.5001C13 14.0524 12.5523 14.5001 12 14.5001H4.00004C3.44775 14.5001 3.00004 14.0524 3.00004 13.5001V7.70718L1.85359 8.85363L1.14648 8.14652L7.64648 1.64652ZM8.00004 2.70718L4.00004 6.70718V13.5001H12V6.70718L8.00004 2.70718Z\" fill=\"#282C33\" />\n</g>\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home.svg
// module id = U9Ws
// module chunks = 140